module.exports = __webpack_public_path__ + "img/img10.d42b2bcf.png";